var environment = process.env.NODE_ENV ? process.env.NODE_ENV : 'development';
environment = "production";
export default require(`./${environment}`).default;